import { SomethingWentWrong } from "@/application/providers/error-boundary/error-boundary";

export const ERROR_PATH = "/error";

export default function ErrorPage() {
  const params = new URLSearchParams(window.location.search);
  const message = params.get("message");

  return (
    <SomethingWentWrong
      message={message}
      onClick={() => {
        window.location.assign("/");
      }}
    />
  );
}
